// extracted by mini-css-extract-plugin
module.exports = {"base":"styles_base__1B8XH","card":"styles_card__36nMN"};